import { startCase } from "lodash";
import { FC } from "react";

import { HeaderTopTitleStyled } from "./header.top.styled";

interface IHeaderTopTitle {
  mainTitle: string;
}

export const HeaderTopTitle: FC<IHeaderTopTitle> = ({ mainTitle }) => {
  return (
    <HeaderTopTitleStyled>
      <h1>{startCase(mainTitle)}</h1>
    </HeaderTopTitleStyled>
  );
};
